import dynamic from 'next/dynamic';
import { PropertyCardProps } from './PropertyCard.types';
import { useDttStore } from '../../../../store';

const PropertyCardBau = dynamic<PropertyCardProps>(() => import('./PropertyCard').then(mod => mod.PropertyCard));
const PropertyCardDtt = dynamic<PropertyCardProps>(() => import('./PropertyCardDtt').then(mod => mod.PropertyCardDtt));

export const PropertyCard = (props: PropertyCardProps) => {
  const { isDtt } = useDttStore();

  return isDtt ? <PropertyCardDtt {...props} /> : <PropertyCardBau {...props} />;
};
